<template>
  <div class="LoginConfirmationCode lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto lxn-border-round">
    <div class="LoginConfirmationCode-d0">
      <CurveWithSvg>
        <template v-slot:default>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" rightIcon="" leftIcon="arrowLeft" centerText=""></TopNav>
        </template>
        <template v-slot:svg>
          <svg class="lxn-w100 lxn-h100 lxn-display-block" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 250 250"><circle cx="124" cy="124" r="125" fill="#4fb0e1" enable-background="new"/><path d="M163.46 191H86.54c-1.66 0-3-1.34-3-3V62c0-1.66 1.34-3 3-3h76.92c1.66 0 3 1.34 3 3v126c0 1.66-1.35 3-3 3z" fill="#204c61"/><path d="M87.82 66H162v112.74H87.82zm32.74 118.03h8.88v2.05h-8.88z" fill="#fff"/><path d="M87.82 66c.84.8 74.18 112.74 74.18 112.74H87.82V66z" opacity=".1" fill="#204c61" enable-background="new"/><path d="M149.68 106.46v30.45c0 1.2-.96 2.15-2.15 2.15H119.6l-11.2 11.2v-11.2h-5.78c-1.2 0-2.15-.96-2.15-2.15v-30.45c0-1.2.96-2.15 2.15-2.15h44.9c1.2 0 2.15.96 2.15 2.15z" fill="#bcbec0"/><path d="M116.26 121.68a3.15 3.15 0 1 1-3.15-3.15c1.75 0 3.15 1.4 3.15 3.15zm23.94 0a3.15 3.15 0 1 1-6.3 0 3.15 3.15 0 1 1 6.3 0zm-11.97 0a3.15 3.15 0 1 1-6.3 0 3.15 3.15 0 0 1 6.3 0z" fill="#21a4de"/></svg>
        </template>
      </CurveWithSvg>
    </div>
    <div class="LoginConfirmationCode-body lxn-w100">
      <div :class="[$store.getters.language.font, $store.getters.language.directionClass]" class="LoginConfirmationCode-title lxn-w100 lxn-title lxn-text-center">
        {{$store.getters.language.texts.LoginConfirmationCode_title}}
      </div>
      <div :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]" class="LoginConfirmationCode-text lxn-w100 lxn-text lxn-text-justify">
        {{$store.getters.language.texts.LoginConfirmationCode_text}}
      </div>
      <div v-if="timeUp" class="LoginConfirmationCode-button">
        <CustomButton @click="resendConfirmationCode" bgColor="#1EA5DE" textColor="#FFFFFF" iconRight="retry" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" :iconRightPadding="8" :useLanguageDirection="true">
          {{$store.getters.language.texts.LoginConfirmationCode_retry}}
        </CustomButton>
      </div>
      <div v-else class="LoginConfirmationCode-button">
        <CustomButton bgColor="#ECECEC" textColor="#53636C">
          <span v-if="$store.getters.language.texts.isRTL">
            {{timerSecs}} : {{timerMins}}
          </span>
          <span v-else>
            {{timerMins}} : {{timerSecs}}
          </span>
        </CustomButton>
      </div>
      <div v-if="!timeUp" class="LoginConfirmationCode-input-placeholder-wrapper lxn-pos-rel">
        <div class="lxn-w100 lxn-h100">
          <DigitPlaceHolder :index="0" :confirmationCode="confirmationCode" :focused="inputFocused" />
          <DigitPlaceHolder :index="1" :confirmationCode="confirmationCode" :focused="inputFocused" />
          <DigitPlaceHolder :index="2" :confirmationCode="confirmationCode" :focused="inputFocused" />
          <DigitPlaceHolder :index="3" :confirmationCode="confirmationCode" :focused="inputFocused" />
          <DigitPlaceHolder :index="4" :confirmationCode="confirmationCode" :focused="inputFocused" />
        </div>
        <div class="LoginConfirmationCode-input-wrapper lxn-h100 lxn-pos-abs">
          <input ref="confirmationCodeInput" v-model="confirmationCode" @input="inputChanged" @focus="inputFocusHandler" class="LoginConfirmationCode-input lxn-w100 lxn-h100" type="tel" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapActions } from 'vuex'
import CurveWithSvg from '@/components/CurveWithSvg.vue'
import CustomButton from '@/components/CustomButton.vue'
import DigitPlaceHolder from '@/components/loginConfirmationCode/digitPlaceHolder.vue'
import TopNav from '@/components/TopNav.vue'



export default {
  name: 'LoginConfimationCode',
  components: {
    CurveWithSvg,
    CustomButton,
    DigitPlaceHolder,
    TopNav
  },
  data: function() {
    return {
      confirmationCode: '',
      inputFocused: false,
      timerSecondsLeft: 120,
      timeoutHandle: -1,
      timeUp: false,
    }
  },
  computed: {
    timerMins: function () {
      var minsLeft = Math.floor(this.timerSecondsLeft / 60);
      if(minsLeft < 10){
        return '0' + minsLeft;
      }else{
        return minsLeft;
      }
    },
    timerSecs: function () {
      var secsLeft = Math.floor(this.timerSecondsLeft % 60);
      if(secsLeft < 10){
        return '0' + secsLeft;
      }else{
        return secsLeft;
      }
    },
  },
  mounted: function () {
    this.tickTimer();
  },
  destroyed: function () {
    clearTimeout(this.timeoutHandle);
  },
  methods: {
    goBack: function () {
      this.$router.go(-1);
    },
    tickTimer: function () {
      if(this.timerSecondsLeft > 0){
        this.timeoutHandle = setTimeout(function () {
          this.timerSecondsLeft--;
          this.tickTimer();
        }.bind(this), 1000);
      }else{
        this.timeUp = true;
      }
    },
    inputFocusHandler: function () {
      this.inputFocused = true;
    },
    inputChanged: function () {
      if(this.confirmationCode.length == 5){
        this.$refs.confirmationCodeInput.blur();
        this.checkConfirmationCode(this.confirmationCode);
      }
    },
    checkConfirmationCode: function (confirmationCode) {
      this.$store.commit('setAppBusy', true);
      this.$store.dispatch('checkLoginVerificationKey', confirmationCode).then(function (response) {
          // console.log(response);
          if(response.data.status == 'success'){
            this.$store.commit('setLoginToken', response.data.aux_auth_token);
            this.$store.commit('setLoggedIn', true);
            this.$store.commit('saveState');
            this.$router.push('/lexaIntro');
          }else{
            this.confirmationCode = '';
            alert(this.$store.getters.language.texts.LoginConfirmationCode_failMessage);
          }
        }.bind(this))
        .catch(function () {
          // console.log(error);
          alert(this.$store.getters.language.texts.Common_internetError);
          this.confirmationCode = '';
          this.inputFocused = false;
        }.bind(this))
        .finally(function () {
          this.$store.commit('setAppBusy', false);
        }.bind(this));
    },
    resendConfirmationCode: function () {
      this.$store.commit('setAppBusy', true);
      this.$store.dispatch('getLoginVerificationKey', this.$store.state.user.mobileNumber).then(function (response) {
        // console.log(response);
        if(response.data.status == 'success'){
          this.$store.commit('setUserUUID', response.data.user_uuid);
          this.timeUp = false;
          this.timerSecondsLeft = 120;
          this.tickTimer();
        }else{
          alert(this.$store.getters.language.texts.LoginRegister_serverResponseFail);
        }
      }.bind(this))
      .catch(function () {
        // console.log(error);
        alert(this.$store.getters.language.texts.Common_internetError);
      }.bind(this))
      .finally(function () {
        this.$store.commit('setAppBusy', false);
      }.bind(this));
    },
    ...mapActions([
      'getLoginVerificationKey'
    ]),
  }
}
</script>

<style>
  .LoginConfirmationCode {
    background-color: #ffffff;
    padding: 18px;
    padding-top: 0;
  }
  .LoginConfirmationCode-d0 {
    height: 40vh;
  }
  .LoginConfirmationCode-title {
    margin-top: 20px;
    height: 30px;
    color: #1EA5DE;
    line-height: 30px;
  }
  .LoginConfirmationCode-text {
    margin-top: 14px;
    color: #53636C;
  }
  .LoginConfirmationCode-button {
    margin-top: 20px;
  }
  .LoginConfirmationCode-input-placeholder-wrapper {
    height: 50px;
    margin-top: 20px;
  }
  .LoginConfirmationCode-input-wrapper {
    width: 100%;
    top: 0;
    left: 0;
  }
  .LoginConfirmationCode-input {
    background-color: transparent;
    color: transparent;
    caret-color: transparent;
  }
  .LoginConfirmationCode-input::selection {
    background-color: transparent;
    color: transparent;
  }
</style>
